import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b97cd934"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "パスワード変更", -1))
const _hoisted_3 = { class: "content has-background-contents shadow" }
const _hoisted_4 = { class: "navigation" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" トップページに戻る ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OuterPasswordComplete = _resolveComponent("OuterPasswordComplete")!
  const _component_DssIcon = _resolveComponent("DssIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_OuterPasswordComplete)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toTop && _ctx.toTop(...args))),
        onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/dms/outer'))),
        class: "button-toTop"
      }, [
        _createVNode(_component_DssIcon, { icon: 'arrow-left' }),
        _hoisted_5
      ], 32)
    ])
  ], 64))
}